import { motion } from "framer-motion";
import SectionTitle from "../ui/SectionTitle";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, Autoplay } from "swiper/modules";

import "swiper/css";
import "swiper/css/pagination";

import { FaQuoteLeft, FaStar } from "react-icons/fa";

const testimonials = [
  {
    id: 1,
    name: "John Anderson",
    position: "CEO",
    company: "Creative Studio",
    image: "/images/testimonial1.webp",
    review:
      "Moobeen transformed our outdated website into a fast, modern React application. Communication was excellent and every milestone was delivered on time.",
  },
  {
    id: 2,
    name: "Sarah Williams",
    position: "Marketing Director",
    company: "Digital Agency",
    image: "/images/testimonial2.webp",
    review:
      "Excellent frontend developer with strong attention to detail. The website loads incredibly fast, looks amazing on every device and performs exceptionally well.",
  },
  {
    id: 3,
    name: "David Brown",
    position: "Business Owner",
    company: "Steel Company",
    image: "/images/testimonial3.webp",
    review:
      "Our Next.js website exceeded expectations. The SEO improvements and performance optimizations significantly improved our online visibility.",
  },
  {
    id: 4,
    name: "Emily Wilson",
    position: "Project Manager",
    company: "Software Company",
    image: "/images/testimonial4.webp",
    review:
      "Professional, reliable and highly skilled. Every feature was implemented exactly as requested with outstanding code quality.",
  },
];

export default function Testimonials() {
  return (
    <section
      id="testimonials"
      className="section relative overflow-hidden bg-[#050816]"
    >
      <div className="absolute left-0 top-0 h-96 w-96 rounded-full bg-blue-600/10 blur-[140px]" />

      <div className="absolute right-0 bottom-0 h-96 w-96 rounded-full bg-cyan-500/10 blur-[140px]" />

      <div className="container">

        <SectionTitle
          subtitle="Testimonials"
          title="What Clients Say"
        />

        <div className="max-w-3xl mb-16">

          <p className="text-slate-400 text-lg leading-8">
            Building long-term relationships through quality development,
            transparent communication and reliable project delivery.
          </p>

        </div>

        <Swiper
          modules={[Pagination, Autoplay]}
          slidesPerView={1}
          spaceBetween={30}
          loop
          autoplay={{
            delay: 5000,
            disableOnInteraction: false,
          }}
          pagination={{
            clickable: true,
          }}
          breakpoints={{
            768: {
              slidesPerView: 2,
            },
          }}
        >

          {testimonials.map((item) => (

            <SwiperSlide key={item.id}>

              <motion.div
                whileHover={{
                  y: -10,
                }}
                transition={{
                  duration: .3,
                }}
                className="group rounded-[32px] border border-white/10 bg-white/5 p-8 backdrop-blur-lg h-full"
              >

                <div className="flex items-center justify-between">

                  <FaQuoteLeft className="text-5xl text-blue-500 opacity-70" />

                  <div className="flex gap-1">

                    {[...Array(5)].map((_, index) => (

                      <FaStar
                        key={index}
                        className="text-yellow-400"
                      />

                    ))}

                  </div>

                </div>

                <p className="mt-10 text-slate-300 leading-8">

                  "{item.review}"

                </p>

                <div className="mt-10 flex items-center gap-5">

                  <img
                    src={item.image}
                    alt={item.name}
                    className="h-16 w-16 rounded-full object-cover border-2 border-blue-500"
                  />

                  <div>

                    <h3 className="font-bold text-xl">

                      {item.name}

                    </h3>

                    <p className="text-slate-400">

                      {item.position}

                    </p>

                    <span className="text-blue-400 text-sm">

                      {item.company}

                    </span>

                  </div>

                </div>

              </motion.div>

            </SwiperSlide>

          ))}

        </Swiper>

        <div className="mt-24 grid gap-8 md:grid-cols-3">

          <div className="rounded-3xl border border-white/10 bg-white/5 p-10 text-center">

            <h3 className="text-5xl font-black text-blue-500">

              1000+

            </h3>

            <p className="mt-4 text-slate-400">

              Successful Projects

            </p>

          </div>

          <div className="rounded-3xl border border-white/10 bg-white/5 p-10 text-center">

            <h3 className="text-5xl font-black text-blue-500">

              10+

            </h3>

            <p className="mt-4 text-slate-400">

              Years Experience

            </p>

          </div>

          <div className="rounded-3xl border border-white/10 bg-white/5 p-10 text-center">

            <h3 className="text-5xl font-black text-blue-500">

              200+

            </h3>

            <p className="mt-4 text-slate-400">

              Happy Clients

            </p>

          </div>

        </div>

      </div>
    </section>
  );
}